<div
  class="cv-page cv12"
  [ngClass]="{ 'thumbnail-view': isThumbnail }"
>
  <div class="cv-frame">
    <!-- HEADER -->
    <header class="cv-header">
      <div class="name-block">
        <h1 class="name">{{ data.firstName }} {{ data.lastName }}</h1>
        <p
          class="designation"
          *ngIf="data.designation"
        >
          {{ data.designation }}
        </p>
      </div>

      <div class="contact-block">
        <p *ngIf="data.contactDetails?.number">
          📞 {{ data.contactDetails.number }}
        </p>
        <p *ngIf="data.contactDetails?.email">
          ✉ {{ data.contactDetails.email }}
        </p>
        <p *ngIf="data.contactDetails?.address">
          📍 {{ data.contactDetails.address || data?.city }}
        </p>
        <p *ngIf="data.contactDetails?.linkedIn">
          in {{ data.contactDetails.linkedIn }}
        </p>
      </div>
    </header>

    <!-- SUMMARY -->
    <div class="cv-summary">
      <section
        class="summary"
        *ngIf="data.about"
      >
        <h3 class="section-title">SUMMARY</h3>
        <p>{{ data.about }}</p>
      </section>
    </div>

    <div class="cv-body">
      <!-- LEFT COLUMN -->
      <aside class="left-col">
        <section
          class="education"
          *ngIf="data.educations?.length"
        >
          <h3 class="section-title blue">EDUCATION</h3>
          <div
            *ngFor="let edu of data.educations"
            class="edu"
          >
            <div class="degree">{{ edu.courseName }}</div>
            <div class="uni">{{ edu.universityName }}</div>
            <div class="timeline">{{ edu.formattedDate }}</div>
            <div
              class="location"
              *ngIf="edu.location"
            >
              {{ edu.location }}
            </div>
          </div>
        </section>

        <section
          class="skills"
          *ngIf="data.skills?.length"
        >
          <h3 class="section-title blue">SKILLS</h3>
          <ul>
            <li *ngFor="let skill of data.skills">{{ skill }}</li>
          </ul>
        </section>

        <section
          class="awards"
          *ngIf="data.certifications?.length"
        >
          <h3 class="section-title blue">CERTIFICATIONS</h3>
          <ul>
            <li *ngFor="let cer of data.certifications">
              <span *ngIf="cer.name">{{ cer.name }}</span>
              <span *ngIf="cer.authority"> ({{ cer.authority }})</span>
            </li>
          </ul>
        </section>
      </aside>

      <!-- RIGHT COLUMN -->
      <main class="right-col">
        <section
          class="experience"
          *ngIf="data.experience?.length"
        >
          <h3 class="section-title">EXPERIENCE</h3>
          <div
            class="exp-item"
            *ngFor="let exp of data.experience"
          >
            <h4 class="job-title">{{ exp.Title }}</h4>
            <p class="dates-location">
              {{ exp.startDate }} - {{ exp.endDate || 'Present' }}
            </p>
            <ul class="description-points">
              <li *ngFor="let point of exp.descriptionPoints">{{ point }}</li>
            </ul>
          </div>
        </section>
      </main>
    </div>
  </div>
</div>
